// converts countryLang format to UsEn
const convertCountryLangFormat = function (countryLang) {
    return countryLang.length === 4 ? `${countryLang.charAt(0).toUpperCase()}${countryLang.charAt(1)}${countryLang.charAt(2).toUpperCase()}${countryLang.charAt(3)}` : `UsEn`;
}

exports.countryLangFromUrl = function (uri) {
    const pattern = /^.([\w,-]*)\/([\w,-]*)\/([\w,-]*)\/(.*)/;
    let countryLang = uri.replace(pattern, `$2$3`);
    return convertCountryLangFormat(countryLang);
}

exports.countryFromUrl = function (uri) {
    const pattern = /^.([\w,-]*)\/([\w,-]*)\/([\w,-]*)\/(.*)/;
    let country = uri.replace(pattern, `$2`);
    return country.length === 2 ? `${country}` : `au`;
}

exports.convertCountryLangFormat = convertCountryLangFormat;